export default "__VITE_ASSET__BFcIBvcx__"